module.exports = __webpack_public_path__ + "img/corina.db9b7dc9.png";